export default __webpack_public_path__ + "static/media/date.ae0e3cfb.svg";